import {Component, OnInit, Input, Output, EventEmitter, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';

import {countryConfig} from 'src/country-config/country-config';

@Component({
  selector: 'app-phone-code',
  templateUrl: './phone-code.component.html',
  styleUrls: ['./phone-code.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PhoneCodeComponent),
    multi: true,
  }],
})
export class PhoneCodeComponent implements OnInit {
  @Input() placeholder = '';
  @Input() idPrefix;
  @Input() prefix;
  @Input() customClasses: string;

  @Output() changeValue: EventEmitter<string> = new EventEmitter();

  code: any;
  codes: any[] = countryConfig.phoneCode;
  isDisabled: boolean;
  onChange = (_: any) => { };
  onTouch = () => { };

  ngOnInit() {
    this.code = (this.codes.length > 0) ? this.codes[0] : 'N/A';
  }

  writeValue(code: any): void {
    this.code = code || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  setCode(value: string) {
    this.code = value;
    this.changeValue.emit(value);
  }
}
